var _ = require('lodash');
var pomUpdates = require('ub_legacy/lp/pom/updates/updates');


// See LP-8819 and PB-677

pomUpdates.add(Object.extend({
  minVersion : '2.5',
  version    : '2.6',

  run: function(jso) {
    if (this.checkVersion(jso)) {

      _(jso.elements)
        .filter(function(el) {
          return el.type === 'lp-pom-form';
        })
        .each(function(el) {
          if (el.confirmationPageElements) {
            delete el.confirmationPageElements;
          }
        }).value();

      jso.version = this.version;
    }
  }

}, window.lp.pom.updater));



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/pom/updates/2.6.js
// module id = 443
// module chunks = 0 1